import { render } from "./ListFDAssignedDocuProj.vue?vue&type=template&id=92cd385a"
import script from "./ListFDAssignedDocuProj.vue?vue&type=script&lang=js"
export * from "./ListFDAssignedDocuProj.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__